module.exports = __webpack_public_path__ + "img/3_hsgeoje.0642b698.jpg";